export const ERROR_FILE_MESSAGE = 'Error processing files';

export const INFO_FILE_MESSAGE = 'Files processed successfully';

export const ERROR_FILE_DOWNLOAD_MESSAGE = 'No file available for download';

export const ERROR_EXCEL_FILE_MESSAGE = 'Error parsing Excel file';
